export default "__VITE_ASSET__D4PfU2oM__"